module.exports = __webpack_public_path__ + "static/media/oh-yeah.afb82f52.gif";


//////////////////
// WEBPACK FOOTER
// ./src/oh-yeah.gif
// module id = 32
// module chunks = 0